export default {
    props: {
        dataColorField: {
            type: String,
            default: undefined,
            kComposite: 'dataColorField'
        }, 
        dataSource: {
            type: [Object, Array],
            default: undefined,
            kComposite: 'dataSource'
        }, 
        dataSourceRef: {
            type: String,
            default: undefined,
            kComposite: 'dataSourceRef'
        }, 
        dataTextField: {
            type: String,
            default: undefined,
            kComposite: 'dataTextField'
        }, 
        dataValueField: {
            type: String,
            default: undefined,
            kComposite: 'dataValueField'
        }, 
        field: {
            type: String,
            default: undefined,
            kComposite: 'field'
        }, 
        multiple: {
            type: Boolean,
            default: undefined,
            kComposite: 'multiple'
        }, 
        name: {
            type: String,
            default: undefined,
            kComposite: 'name'
        }, 
        title: {
            type: String,
            default: undefined,
            kComposite: 'title'
        }, 
        valuePrimitive: {
            type: Boolean,
            default: undefined,
            kComposite: 'valuePrimitive'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-scheduler-vue-wrapper/src/KendoSchedulerResource/Resources.js